import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

export function formatDate(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric'
  });
}

export function formatDateTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function formatTime(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  return date.toLocaleTimeString('en-GB', {
    hour: '2-digit',
    minute: '2-digit'
  });
}

export function getTodayDate() {
  return new Date().toISOString().split('T')[0];
}

export function getDateRange(days) {
  const end = new Date();
  const start = new Date();
  start.setDate(start.getDate() - days);
  return {
    start: start.toISOString().split('T')[0],
    end: end.toISOString().split('T')[0]
  };
}

export function capitalize(str) {
  if (!str) return '';
  return str.charAt(0).toUpperCase() + str.slice(1).replace(/_/g, ' ');
}

export function getStatusColor(status) {
  switch (status?.toLowerCase()) {
    case 'completed':
    case 'safe':
    case 'resolved':
      return 'status-safe';
    case 'warning':
    case 'medium':
      return 'status-warning';
    case 'critical':
    case 'high':
    case 'overdue':
      return 'status-critical';
    case 'pending':
    case 'low':
    default:
      return 'status-pending';
  }
}

export function isTemperatureAcceptable(temp, location) {
  switch (location?.toLowerCase()) {
    case 'fridge':
      return temp >= 0 && temp <= 5;
    case 'freezer':
      return temp <= -18;
    case 'hot_hold':
    case 'hot hold':
      return temp >= 63;
    case 'delivery':
      return temp <= 8;
    default:
      return true;
  }
}

export function getTemperatureRange(location) {
  switch (location?.toLowerCase()) {
    case 'fridge':
      return '0-5°C';
    case 'freezer':
      return '-18°C or below';
    case 'hot_hold':
    case 'hot hold':
      return '63°C or above';
    case 'delivery':
      return '8°C or below';
    default:
      return 'N/A';
  }
}
